import { FC } from "react";
import { StaticInfoMessage } from "shared/components/feedback/InfoMessage/StaticInfoMessage";
import { Button, Stack } from "shared/components/Spor";

type InfoMessageWithRetryButtonProps = {
  message: string;
  retryFn: () => void;
};
export const InfoMessageWithRetryButton: FC<
  InfoMessageWithRetryButtonProps
> = ({ message, retryFn }) => (
  <Stack flexDirection="row">
    <StaticInfoMessage
      semantics="info"
      summary={message}
      style={{ gridColumn: "span 2" }}
      inlineButton={
        <Button
          onClick={(ev) => {
            ev.preventDefault();
            retryFn();
          }}
          size="xs"
          variant="tertiary"
          width="100%"
        >
          Prøv på nytt
        </Button>
      }
    />
  </Stack>
);
